document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("li.menu-drawer__parent-link").forEach((li) => {
    const trigger = li.querySelector("a");
    const submenu = li.querySelector(".menu-drawer__sub-nav");
    if (!trigger || !submenu) return;

    li.setAttribute("aria-haspopup", "true");
    li.setAttribute("aria-expanded", "false");
    submenu.setAttribute("aria-hidden", "true");
    submenu.setAttribute("inert", "");
    const subLinks = Array.from(submenu.querySelectorAll("a"));
    subLinks.forEach((link) => link.setAttribute("tabindex", "-1"));

    function setOpen(isOpen) {
      li.setAttribute("aria-expanded", String(isOpen));
      submenu.setAttribute("aria-hidden", String(!isOpen));

      if (isOpen) {
        submenu.removeAttribute("inert");
      } else {
        submenu.setAttribute("inert", "");
      }

      subLinks.forEach((link) =>
        link.setAttribute("tabindex", isOpen ? "0" : "-1")
      );
    }

    li.addEventListener("mouseenter", () => setOpen(true));
    li.addEventListener("focusin", () => setOpen(true));
    li.addEventListener("mouseleave", () => setOpen(false));
    li.addEventListener("focusout", (e) => {
      if (!li.contains(e.relatedTarget)) setOpen(false);
    });

    trigger.addEventListener("keydown", (e) => {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setOpen(true);
        subLinks[0].focus();
      }
      if (
        e.key === "Escape" &&
        submenu.getAttribute("aria-hidden") === "false"
      ) {
        e.preventDefault();
        setOpen(false);
        trigger.focus();
      }
    });
    subLinks.forEach((link, idx) => {
      link.addEventListener("keydown", (e) => {
        switch (e.key) {
          case "ArrowDown":
            e.preventDefault();
            subLinks[(idx + 1) % subLinks.length].focus();
            break;
          case "ArrowUp":
            e.preventDefault();
            if (idx === 0) {
              setOpen(false);
              trigger.focus();
            } else {
              subLinks[idx - 1].focus();
            }
            break;
          case "Escape":
            e.preventDefault();
            setOpen(false);
            trigger.focus();
            break;
        }
      });
    });
  });
});
